<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    :title="$t('fixDutyFine.processPenaltyTitle')"
    width="600px"
    @close="handleClose"
  >
    <div class="penalty-dialog-content">
      <!-- 顶部信息卡 -->
      <div class="info-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">{{ $t('fixDutyFine.selected') }}</span>
              <span class="info-value text-bold">
                {{ count }} {{ $t('fixDutyFine.ticketsUnit') }}
              </span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">{{ $t('base.billingMonth') }}</span>
              <span class="info-value">{{ month || '--' }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 认罚/申诉 单选组 (注意这里 label 已经改为 1 和 2) -->
      <div class="radio-group-block">
        <el-radio-group v-model="actionType" class="custom-radio-group">
          <el-radio :label="1" class="custom-radio">
            <span class="radio-text">{{ $t('fixDutyFine.accept') }}</span>
          </el-radio>
          <el-radio :label="2" class="custom-radio">
            <span class="radio-text">{{ $t('fixDutyFine.appeal') }}</span>
          </el-radio>
        </el-radio-group>
      </div>

      <!-- 原因输入框 -->
      <div class="textarea-block">
        <el-input
          v-model="reason"
          :placeholder="
            actionType === 2
              ? $t('fixDutyFine.appealReasonPlaceholder')
              : $t('fixDutyFine.acceptReasonPlaceholder')
          "
          :rows="4"
          maxlength="500"
          show-word-limit
          type="textarea"
        />
      </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('fixDutyFine.cancel') }}</el-button>
      <el-button :loading="submitting" type="success" @click="handleSubmit">{{ $t('fixDutyFine.confirmSubmit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { lmReconciliationProcess } from '@/api/definiteResponsibilityAndPenalty';

export default {
  name: 'ProcessPenaltyDialog',
  data() {
    return {
      count: 0,
      visible: false,
      actionType: 1, // 1: 认罚, 2: 申诉
      reason: '',
      submitting: false,
      currentRecord: {}, // 存储当前父组件传入的选中数据（用于组装提交报文）
      mode: 'single', // 'single' 或 'batch'
      month: '' // 账单月份，由父组件传入
    };
  },
  methods: {
    // 暴露给父组件的方法：打开弹窗
    open(record) {
      console.log(record);
      // 1. 判断是数组还是对象
      const isArray = Array.isArray(record);
      // 2. 基础校验：如果传进来的数据为空，或者数组长度为0，阻止打开并提示
      if ((isArray && record.length === 0) || (!isArray && Object.keys(record).length === 0)) {
        this.$message.warning(this.$t('fixDutyFine.selectProcessRecords'));
        return;
      }
      // 3. 根据类型分别处理，确保后续逻辑稳定
      if (isArray) {
        // 如果是数组（批量处理），强制 mode 为 batch
        this.currentRecord = record;
        this.mode = 'batch';
        this.count = record.length; // 自动计算数量，防止外面传错
        // 4. 设置月份和重置表单状态
        this.month = this.currentRecord[0].reconciliationPeriod;
      } else {
        // 如果是对象（单个处理），强制 mode 为 single
        this.currentRecord = record;
        this.mode = 'single';
        this.count = 1; // 单个就是 1
        // 4. 设置月份和重置表单状态
        this.month = this.currentRecord.reconciliationPeriod;
      }

      this.actionType = 1; // 每次打开重置为认罚
      this.reason = '';
      this.submitting = false;
      this.visible = true;
    },
    // 提取需要提交的 ids
    getTargetIds() {
      // 直接根据 isArray 判断提取即可
      if (Array.isArray(this.currentRecord)) {
        return this.currentRecord.map((item) => item.id).filter((id) => id !== undefined);
      } else if (this.currentRecord && this.currentRecord.id) {
        return [this.currentRecord.id];
      }
      return []; // 兜底
    },
    async handleSubmit() {
      // 校验：申诉必须填原因
      if (this.actionType === 2 && !this.reason.trim()) {
        this.$message.warning(this.$t('fixDutyFine.appealReasonRequired'));
        return;
      }

      // 组装接口所需参数
      const payload = {
        ids: this.getTargetIds(),
        actionType: this.actionType,
        appealReason: this.actionType === 2 ? this.reason.trim() : '' // 申诉必填，认罚可以不填
      };

      // 如果 ids 为空，阻止提交
      if (payload.ids.length === 0) {
        this.$message.error(this.$t('fixDutyFine.invalidWaybillId'));
        return;
      }

      this.submitting = true;
      try {
        // 调用后端接口
        const res = await lmReconciliationProcess(payload);

        if (res.code === 200) {
          this.$message.success(this.$t('fixDutyFine.processSuccess'));
          this.submitting = false;
          this.close();

          // 通知父组件刷新列表（新增：提交成功事件）
          this.$emit('submit-success', payload);
        } else {
          this.$message.error(res.msg || this.$t('fixDutyFine.processFailed'));
          this.submitting = false;
        }
      } catch (error) {
        console.error('处理扣罚接口异常', error);
        this.$message.error(this.$t('fixDutyFine.networkError'));
        this.submitting = false;
      }
    },

    // 关闭弹窗
    close() {
      this.visible = false;
      this.submitting = false;
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.penalty-dialog-content {
  padding: 0 10px;
}

/* 顶部信息卡样式 */
.info-block {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 15px 20px;
  margin-bottom: 20px;

  .info-item {
    display: flex;
    flex-direction: column;

    .info-label {
      font-size: 12px;
      color: #909399;
      margin-bottom: 6px;
    }

    .info-value {
      font-size: 14px;
      color: #303133;
      font-weight: bold;

      &.text-bold {
        color: #303133;
      }
    }
  }
}

/* 单选按钮组样式 (还原UI图大小和边框) */
.radio-group-block {
  margin-bottom: 20px;

  .custom-radio-group {
    display: flex;
    justify-content: space-between;
    width: 100%;

    /* 覆盖 Element UI 默认样式，让单选框看起来像大按钮 */
    ::v-deep .el-radio {
      width: 48%;
      margin-right: 0;
      border: 1px solid #dcdfe6;
      border-radius: 6px;
      padding: 15px 20px;
      text-align: center;
      background: #fff;
      transition: all 0.3s;

      .el-radio__label {
        font-size: 15px;
        font-weight: 500;
        color: #303133;
        padding-left: 8px;
      }

      &.is-checked {
        border-color: #00b050;
        background-color: #f0f9eb; // 浅绿色背景
        box-shadow: 0 0 0 1px #00b050 inset; // 模拟UI图内部框线
      }

      &.is-checked .el-radio__label {
        color: #303133;
      }
    }
  }
}

/* 文本域样式 */
.textarea-block {
  ::v-deep .el-textarea__inner {
    border-radius: 6px;
    padding: 12px;
  }
}

/* 底部按钮样式 */
.dialog-footer {
  text-align: right;

  .el-button--success {
    background-color: #00b050;
    border-color: #00b050;

    &:hover,
    &:focus {
      background-color: #009146;
      border-color: #009146;
    }
  }
}
</style>
